module.exports = __webpack_public_path__ + "img/survey-is-created.06b28153.svg";